import { useFlag } from '~/components/Flag';
import { t } from '~/components/I18n';
import crownCitizen from '~/components/Icon/Citizen/crownCitizen.png';
import { useMember } from '~/components/Member/Member.hooks';
import { appliedVersion, isTargetVersion } from '~/components/Quick/Menu/QuickMenu.hooks';
import { QuickMenuItem } from '~/components/Quick/Menu/QuickMenuItem';

// NOTE hide description for now
export const LevelUpQuickMenuItem = () => {
  const {
    data: { isLoggedIn },
  } = useMember();
  const { hidden } = useFlag({
    name: 'MEMBERSHIP',
    value: appliedVersion,
    disabled: !isTargetVersion,
  });
  // const { data: statuses } = useLevelStatuses();
  // const availableLevel = useMemo(
  //   () => statuses.find((status) => status.canLevelUp)?.level,
  //   [statuses]
  // );
  const active = isLoggedIn && !hidden;

  return (
    <QuickMenuItem
      active={active}
      image={crownCitizen}
      label={t('citizen_quick_levelup')}
      // description={availableLevel && <T name="TODO Lv{0} 가능" options={[availableLevel]} />}
    />
  );
};
